/**
 * Custom Header Drawer — Accordion Controller
 * Manages smooth max-height animation for accordion submenus.
 * Pattern: <details> toggle controls adjacent <ul> sibling's max-height.
 */

if (!customElements.get('custom-accordion-menu')) {
  class CustomAccordionMenu extends HTMLElement {
    constructor() {
      super();
      this.detailsElements = [];
      this.animationDuration = 200; // matches --duration-default (0.2s)
    }

    connectedCallback() {
      this.detailsElements = this.querySelectorAll('.custom-drawer-nav__details');
      this.detailsElements.forEach((details) => {
        details.addEventListener('toggle', this.handleToggle.bind(this));

        // Prevent native details jump — intercept click on summary
        const summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            if (details.open) {
              this.closeAccordion(details);
            } else {
              details.open = true;
              // toggle event fires automatically
            }
          });
        }
      });
    }

    handleToggle(event) {
      const details = event.target;
      const submenu = details.parentElement
        ? details.parentElement.querySelector('.custom-drawer-nav__submenu')
        : null;

      if (!submenu) return;

      if (details.open) {
        this.openAccordion(submenu);
      }
    }

    openAccordion(submenu) {
      // Measure the natural height
      submenu.style.maxHeight = 'none';
      const targetHeight = submenu.scrollHeight;
      submenu.style.maxHeight = '0px';

      // Force reflow
      submenu.offsetHeight;

      // Animate to target height
      submenu.style.maxHeight = targetHeight + 'px';

      // After animation, remove fixed height so content can reflow
      const onEnd = () => {
        submenu.style.maxHeight = 'none';
        submenu.removeEventListener('transitionend', onEnd);
      };
      submenu.addEventListener('transitionend', onEnd);
    }

    closeAccordion(details) {
      const submenu = details.parentElement
        ? details.parentElement.querySelector('.custom-drawer-nav__submenu')
        : null;

      if (!submenu) {
        details.open = false;
        return;
      }

      // Set current height explicitly so transition can animate from it
      submenu.style.maxHeight = submenu.scrollHeight + 'px';

      // Force reflow
      submenu.offsetHeight;

      // Animate to 0
      submenu.style.maxHeight = '0px';

      // After animation, actually close the details
      const onEnd = () => {
        details.open = false;
        submenu.removeEventListener('transitionend', onEnd);
      };
      submenu.addEventListener('transitionend', onEnd);
    }

    disconnectedCallback() {
      this.detailsElements.forEach((details) => {
        details.removeEventListener('toggle', this.handleToggle);
      });
    }
  }

  customElements.define('custom-accordion-menu', CustomAccordionMenu);
}
